import { useEffect } from 'react';
import { logger } from '@/lib/logger';

export const useReloadProtection = () => {
  useEffect(() => {
    // Track page reloads and navigation
    const trackPageLoad = () => {
      const now = Date.now();
      const lastReload = sessionStorage.getItem('lastPageLoad');
      const reloadCount = parseInt(sessionStorage.getItem('reloadCount') || '0');
      
      if (lastReload) {
        const timeSinceLastReload = now - parseInt(lastReload);
        
        if (timeSinceLastReload < 5000) { // Less than 5 seconds
          const newCount = reloadCount + 1;
          sessionStorage.setItem('reloadCount', newCount.toString());
          
          if (newCount > 3) {
            logger.error('🚨 FREQUENT RELOAD DETECTED', {
              count: newCount,
              timeSinceLastReload,
              userAgent: navigator.userAgent,
              url: window.location.href
            });
          }
        } else {
          sessionStorage.setItem('reloadCount', '1');
        }
      }
      
      sessionStorage.setItem('lastPageLoad', now.toString());
    };

    // Track window focus/blur events that might trigger reloads
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        logger.info('🔍 Window became visible', {
          timestamp: new Date().toISOString(),
          previousState: 'hidden'
        });
      } else {
        logger.info('🔍 Window became hidden', {
          timestamp: new Date().toISOString(),
          nextState: 'hidden'
        });
      }
    };

    // Track beforeunload to detect unexpected reloads
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      logger.info('🔄 Page unloading', {
        timestamp: new Date().toISOString(),
        url: window.location.href,
        reason: 'beforeunload'
      });
    };

    trackPageLoad();
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
};